import {useContext} from 'react';
import {Field, Panel} from '../../../../layouts';
import {formatShortDate, formatShortDateShortTime} from '../../../../utils/date-utils';
import {EstimateContext} from '../context/EstimateContext';

export default function EstimateDatesPanel() {

	const { order } = useContext(EstimateContext);

	return (
		<Panel header={'Dates'}>
			<Field label={'Customer Contact Date'} >
				{formatShortDate(order.details.customerContactDate)}
			</Field>
			<Field label={'Scheduled Appointment Date'} >
				{formatShortDateShortTime(order.details.scheduledAppointmentDate)}
			</Field>
		</Panel>
	);
}
